import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { MainLayout } from '@/components/layout'
import { HomePage, VideoPage, SqueezePage, SqueezeFreeformPage, SqueezeSelectorPage } from '@/pages'
import { RedirectProvider } from '@/contexts/redirect-context'

// Hidden squeeze page routes (no layout)
const STANDALONE_ROUTES = ['/x9k2m7p4q1w8', '/no-filter-3', '/nf-4', '/nf-5']

function AppRoutes() {
  const location = useLocation()
  const isStandalone = STANDALONE_ROUTES.includes(location.pathname)

  // Render standalone pages without layout
  if (isStandalone) {
    return (
      <Routes>
        <Route path="/x9k2m7p4q1w8" element={<SqueezePage />} />
        <Route path="/no-filter-3" element={<SqueezePage />} />
        <Route path="/nf-4" element={<SqueezeFreeformPage />} />
        <Route path="/nf-5" element={<SqueezeSelectorPage />} />
      </Routes>
    )
  }

  // Regular pages with layout
  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/video" element={<VideoPage />} />
        <Route path="/video/:tab" element={<VideoPage />} />
        {/* Redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MainLayout>
  )
}

export default function App() {
  return (
    <RedirectProvider>
      <AppRoutes />
    </RedirectProvider>
  )
}
